import { createAsyncTypes } from 'utils/ActionCreator'
import { URL_CONST } from 'utils/urlConsts'

export const INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC = createAsyncTypes(
  'INCIDENTS_ACTIVITY_LOG_REQUEST',
  'IronScales/Dashboard/Home/ActivityFeed'
)
export const CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC = createAsyncTypes(
  'CAMPAIGNS_ACTIVITY_LOG_REQUEST',
  'IronScales/Dashboard/Home/ActivityFeed'
)
export const COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC = createAsyncTypes(
  'COMMENTS_ACTIVITY_LOG_REQUEST',
  'IronScales/Dashboard/Home/ActivityFeed'
)
export const BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC = createAsyncTypes(
  'BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST',
  'IronScales/Dashboard/Home/ActivityFeed'
)

export const INSIGHTS_REQUEST_ASYNC = createAsyncTypes(
  'INSIGHTS_REQUEST',
  'IronScales/Dashboard/Home/ActivityFeed'
)
export const DISMISS_INSIGHTS_REQUEST_ASYNC = createAsyncTypes(
  'DISMISS_INSIGHTS_REQUEST',
  'IronScales/Dashboard/Home/ActivityFeed'
)

export const ADD_COMMENT_REPLY_REQUEST_ASYNC = createAsyncTypes(
  'ADD_COMMENT_REPLY_REQUEST',
  'IronScales/Dashboard/Home/ActivityFeed'
)

export const ACTIVITY_FILTER_CHANGE =
  'IronScales/Dashboard/Home/ActivityFeed/ACTIVITY_FILTER_CHANGE'

export const ACTIVITY_LOG_VIEW_CONST = 0
export const INSIGHTS_VIEW_CONST = 1

export const MAX_ACTIVITIES_CONST = 50

export const ACTIVITY_LOG_FILTER_OPTIONS = [
  { value: 0, label: 'All', id: 'homepage-activityFeed-allFilter' },
  { value: 1, label: 'Incidents', id: 'homepage-activityFeed-incidentsFilter' },
  {
    value: 4,
    label: 'Blocked Attacks',
    id: 'homepage-activityFeed-blockedAttacksFilter',
  },
  {
    value: 2,
    label: 'Phishing Simulation',
    id: 'homepage-activityFeed-phishingSimulationFilter',
  },
  { value: 3, label: 'Comments', id: 'homepage-activityFeed-commentsFilter' },
]

export const BADGES_INDICATIONS_OPTIONS = [
  {
    key: 'incident-emails',
    countKey: 'affectedMailboxes',
    icon: 'mailbox',
    style: { width: '16px', height: '12px' },
  },
  {
    key: 'reporters',
    countKey: 'reportersCount',
    icon: 'reporter',
    style: { width: '15px', height: '16px' },
  },
  {
    key: 'links',
    countKey: 'linksCount',
    icon: 'link',
    style: { width: '14px', height: '16px' },
  },
  {
    key: 'files',
    countKey: 'filesCount',
    icon: 'file',
    style: { width: '12px', height: '16px' },
  },
]

export const MALICIOUS_TYPE_LINK = 1

export const VIP_BEC_OPTIONS = {
  1: { text: 'VIP Impersonation', img: 'vip' },
  2: { text: 'BEC & VIP Impersonation', img: 'bec-and-vip' },
  3: { text: 'Business Email Compromise', img: 'bec' },
}

export const ACTION_MADE_CONST = {
  1: 'QUARANTINED',
  2: 'INLINE MESSAGE DISPLAYED',
  3: 'MOVED TO SPAM',
  4: 'REVERTED',
  5: 'NO ACTION TAKEN',
}

export const LOG_TYPE_OPTIONS = {
  ALL: 0,
  INCIDENT: 1,
  CAMPAIGN: 2,
  COMMENT: 3,
  BLOCKED: 4,
}

export const CAMPAIGN_NOTIFICATION_TYPE_OPTIONS = {
  ENDED: 1,
  TOMORROW: 2,
  IN_3_DAYS: 3,
}

export const INSIGHTS_OPTIONS = {
  holiday: {
    text: '<holiday> is coming, try a special Template for this occasion!',
    action: 'Challenge My Employees',
    url: URL_CONST.awarenessCenter.wizardCampaign,
    logo: '/static/webapp/images/home-dashboard/school-large.svg',
    requiredPerms: ['admin', 'edit_campaigns'],
    replacementParams: { '<holiday>': 'name' },
  },
  add_reporters: {
    text: 'Add more analysts to be notified of new reports/attacks via email to shorten the response time',
    action: 'Add Responders',
    url: URL_CONST.settings.systemAlerts,
    scrollToId: 'incident-section-scroll',
    logo: '/static/webapp/images/home-dashboard/settings-large.svg',
    requiredPerms: ['admin', 'manage_irontraps'],
  },
  profiles_with_no_campaign_email: {
    text: 'Many employees have never received a phishing simulation campaign and might be at risk',
    action: 'Send Campaign',
    url: URL_CONST.awarenessCenter.wizardCampaign,
    logo: '/static/webapp/images/home-dashboard/school-large.svg',
    requiredPerms: ['admin', 'edit_campaigns'],
  },
  no_campaign_email_scheduled: {
    text: 'Keep your employees aware to phishing attacks by running a campaign',
    action: 'Launch Campaign',
    url: URL_CONST.awarenessCenter.wizardCampaign,
    logo: '/static/webapp/images/home-dashboard/school-large.svg',
    requiredPerms: ['admin', 'edit_campaigns'],
  },
  link_scanning_disabled: {
    text: 'Links are not being scanned',
    action: 'Turn On URL Scans',
    url: URL_CONST.settings.incidence,
    logo: '/static/webapp/images/home-dashboard/irontraps-large.png',
    requiredPerms: ['admin', 'manage_irontraps'],
  },
  file_scanning_disabled: {
    text: 'Attachments are not being scanned',
    action: 'Turn On Attachments Scans',
    url: URL_CONST.settings.incidence,
    logo: '/static/webapp/images/home-dashboard/irontraps-large.png',
    requiredPerms: ['admin', 'manage_irontraps'],
  },
  new_vip_discovery: {
    text: "A new VIP end-user(s) was discovered without a 'VIP_Impersonation' tag",
    action: 'Find VIPs',
    url: URL_CONST.mailboxes.vipuser,
    logo: '/static/webapp/images/home-dashboard/sights-large.svg',
    requiredPerms: ['admin'],
  },
  email_notification_off: {
    text: 'End-users are not updated that their reports were classified',
    action: 'Update Settings',
    url: URL_CONST.settings.incidence,
    scrollToId: 'reporter-status-scroll',
    logo: '/static/webapp/images/home-dashboard/irontraps-large.png',
    requiredPerms: ['admin', 'manage_irontraps'],
  },
  increase_themis_threshold: {
    text: {
      keyForMultipleTextOptions: 'type',
      phishing:
        'Decrease Themis threshold to 80% could save <X> hours on classification of phishing.',
      spam: 'Decrease Themis threshold of 70% could save <X> hours on classification of spam.',
    },
    action: 'Optimize Threshold',
    url: URL_CONST.settings.incidence,
    scrollToId: 'themis-threshold-section',
    logo: '/static/webapp/images/home-dashboard/themis-large.svg',
    requiredPerms: ['admin', 'manage_irontraps'],
    replacementParams: { '<X>': 'hoursSaved' },
  },
  reduce_themis_threshold: {
    text: {
      keyForMultipleTextOptions: 'type',
      phishing:
        'Increasing Themis spam threshold to 80% could improve detection accuracy rate by <X>',
      spam: 'Increasing Themis phishing threshold to 70% could improve detection accuracy rate by <X>',
    },
    action: 'Optimize Threshold',
    url: URL_CONST.settings.incidence,
    scrollToId: 'themis-threshold-section',
    logo: '/static/webapp/images/home-dashboard/themis-large.svg',
    requiredPerms: ['admin', 'manage_irontraps'],
    replacementParams: { '<X>': 'savedFps' },
  },
  banners_are_off: {
    text: 'Enable Impersonation Protection to alert your employees about impersonation attempts.',
    action: 'Enable Banners',
    url: URL_CONST.settings.impersonation,
    logo: '/static/webapp/images/home-dashboard/sights-large.svg',
    requiredPerms: ['admin', 'manage_irontraps'],
  },
  change_community_sensitivity: {
    text: 'Adjusting Community sensitivity to medium could improve detection accuracy rate.',
    action: 'Adjust Sensitivity Level',
    url: URL_CONST.settings.community,
    logo: '/static/webapp/images/home-dashboard/federation-large.svg',
    requiredPerms: ['admin', 'manage_irontraps'],
  },
  federation_is_disabled: {
    text: 'Enable Community to detect more suspicious incidents.',
    action: 'Enable Community',
    url: URL_CONST.settings.community,
    logo: '/static/webapp/images/home-dashboard/federation-large.svg',
    requiredPerms: ['admin', 'manage_irontraps'],
  },
  total_time_saved_report: {
    text: 'You have saved approximately <X> hours last month. Share the periodical Incident Summary report with other managers.',
    action: 'Manage recipients',
    url: URL_CONST.settings.systemAlerts,
    logo: '/static/webapp/images/home-dashboard/irontraps-large.png',
    requiredPerms: ['admin', 'manage_irontraps'],
    replacementParams: { '<X>': 'hoursSaved' },
  },
  department_at_risk: {
    text: '<department> is your most targeted department in the last 2 months, send the employees a phishing simulation campaign to improve their awareness',
    action: 'Launch a Campaign',
    url: URL_CONST.awarenessCenter.wizardCampaign,
    logo: '/static/webapp/images/home-dashboard/school-large.svg',
    requiredPerms: ['admin', 'edit_campaigns'],
    replacementParams: { '<department>': 'departmentName' },
  },
  high_click_rate_scenario: {
    text: 'Many companies launched a campaign with a <type> Template that had high click rate, challenge your employees with it to test their awareness.',
    action: 'Challenge My Employees',
    url: URL_CONST.awarenessCenter.wizardCampaign,
    logo: '/static/webapp/images/home-dashboard/school-large.svg',
    requiredPerms: ['admin', 'edit_campaigns'],
    replacementParams: { '<type>': 'campaignType' },
  },
  campaigns_only_plan: {
    text: 'Your employees are vulnerable for phishing attacks and have no active protection!',
    action: 'Protect my organization!',
    url: 'licenseUpgrade',
    logo: '/static/webapp/images/home-dashboard/shield-large.png',
    requiredPerms: ['admin', 'edit_campaigns'],
  },
  is_core_plan: {
    text: 'Improve malicious emails  detection rate by integrating additional premium scanners to your account',
    action: 'Protect my organization!',
    url: 'licenseUpgrade',
    logo: '/static/webapp/images/home-dashboard/shield-large.png',
    requiredPerms: ['admin', 'edit_campaigns'],
  },
  is_email_protect_plan: {
    text: 'Does protecting your incoming emails is enough? Add a full communication-protection layer to make sure your employees are covered',
    action: 'Upgrade to Complete Protect',
    url: 'licenseUpgrade',
    logo: '/static/webapp/images/home-dashboard/shield-large.png',
    requiredPerms: ['admin', 'edit_campaigns'],
  },
}
